import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getTimelines = () => {
  return axios.get('/timeline');
};

export const useTimelines = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ['timeline'],
    queryFn: () => getTimelines(),
  });
};
